import React from 'react';
import EmailAccountTabs from './EmailAccountTabs';

/**
 * EmailTabHeader - Compact header for email tab with folder info and account tabs
 */
const EmailTabHeader = ({
  activeFolder,
  emailCount,
  // EmailAccountTabs props
  emailAccounts,
  activeEmailAccount,
  renamingAccountId,
  renameValue,
  setRenameValue,
  onSelectAccount,
  onStartRename,
  onRename,
  onCancelRename,
  onRemoveAccount,
  onSyncAccount,
  onConnectAccount,
  onAddAccount,
  onReorderAccounts,
  outlookConnected,
  outlookLoading,
  gmailConnected,
  gmailLoading,
  gmailEmail,
  nylasLoading,
  className = ''
}) => {
  return (
    <div className={`px-3 py-2 bg-black flex-shrink-0 ${className}`}>
      <div className="flex items-center gap-3 mb-1.5">
        <h3 className="text-sm font-bold text-white capitalize">{activeFolder}</h3>
        <span className="text-xs text-gray-500">{emailCount} emails</span>
      </div>
      
      {/* Email Account Tabs */}
      <EmailAccountTabs
        accounts={emailAccounts}
        activeAccountId={activeEmailAccount}
        renamingAccountId={renamingAccountId}
        renameValue={renameValue}
        setRenameValue={setRenameValue}
        onSelectAccount={onSelectAccount}
        onStartRename={onStartRename}
        onRename={onRename}
        onCancelRename={onCancelRename}
        onRemoveAccount={onRemoveAccount}
        onSyncAccount={onSyncAccount}
        onConnectAccount={onConnectAccount}
        onAddAccount={onAddAccount}
        onReorderAccounts={onReorderAccounts}
        outlookConnected={outlookConnected}
        outlookLoading={outlookLoading}
        gmailConnected={gmailConnected}
        gmailLoading={gmailLoading}
        gmailEmail={gmailEmail}
        nylasLoading={nylasLoading}
      />
    </div>
  );
};

export default EmailTabHeader;
